
import OrderReorderRow from '@marketplace/components/account/orders/order-reorder-row.vue'
import Checkbox from '@marketplace/components/forms/inputs/checkbox.vue'
import Loader from '@marketplace/components/shared/loaders/loader.vue'
import { ADD_PRODUCTS_TO_CART_MUTATION } from '@marketplace/graphql/cart.js'
import {
    GET_ORDER_PRODUCTS_BY_ID_QUERY,
    GET_TICA_ORDER_DETAILS_BY_ID_QUERY,
} from '@marketplace/graphql/orders.js'
import { trackAddToCart } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalOrderReorder',
    components: {
        Loader,
        Checkbox,
        OrderReorderRow,
    },

    props: {
        orderId: {
            type: String,
            default: '',
        },
        isTicaOrder: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isAllSelectedState: false,
            isButtonLoading: true,
            isLoading: true,
        }
    },

    apollo: {
        order: {
            skip() {
                return this.isTicaOrder
            },
            query: GET_ORDER_PRODUCTS_BY_ID_QUERY,
            variables() {
                return { id: this.orderId }
            },
            result() {
                this.isLoading = this.isButtonLoading = false
            },
        },
        ticaOrder: {
            query: GET_TICA_ORDER_DETAILS_BY_ID_QUERY,
            update: (data) => data.order,
            variables() {
                return { id: this.orderId }
            },
            result() {
                this.isLoading = this.isButtonLoading = false
            },
        },
    },

    computed: {
        ocOrderProductsList() {
            const orderData = this.order?.supplierOrders?.edges
            const productsArray = []
            orderData?.forEach((order) => {
                order.node.products.edges.forEach((product) => {
                    productsArray.push(product.node)
                })
            })
            return productsArray
        },
        ticaProductsList() {
            return this.ticaOrder?.products.map((item) => {
                item.id = item?.listingVariant?.id
                return item
            })
        },

        productsList() {
            const products = this.isTicaOrder
                ? this.ticaProductsList
                : this.ocOrderProductsList
            return products
                ?.map((product) => {
                    product.disabled =
                        !product?.listing ||
                        !product?.listing.isPublished ||
                        product?.listing.isOrderWriterOnly ||
                        !product.storefront?.isPublished ||
                        (!['REORDER_ONLY', 'PUBLISHED'].includes(
                            product.storefront?.status
                        ) &&
                        product.storefront?.isPublished) ||
                        !product?.listingVariantId ||
                        !product?.canBeReordered

                    return product
                })
                .sort((a, b) => a.disabled - b.disabled)
        },
        selectedProducts() {
            return this.productsList?.filter(
                (product) =>
                    product.isSelected &&
                    product.listing?.isPublished &&
                    product?.listingVariantId
            )
        },
        selectedProductsCount() {
            return this.selectedProducts?.length
        },
        hasReorderOnlyProducts() {
            if (!this.selectedProductsCount) {
                return false
            }

            return this.selectedProducts?.some(
                (item) => item.listing?.isReorderOnly
            )
        },
    },

    methods: {
        toggleSelectAll() {
            this.isAllSelectedState = !this.isAllSelectedState
            this.productsList.forEach((product) => {
                if (!product.disabled) {
                    this.$set(product, 'isSelected', this.isAllSelectedState)
                }
            })
        },
        updateSelectedList(payload) {
            this.isAllSelectedState = false
            this.productsList.forEach((product) => {
                if (product.id === payload.id) {
                    this.$set(product, 'isSelected', payload.value)
                }
            })
        },
        closeModal() {
            EventBus.$emit('modal-close')
        },
        addToCart() {
            this.isButtonLoading = true

            const itemsToAddToCart = this.productsList
                .filter(
                    (product) =>
                        product.isSelected &&
                        product.listing?.isPublished &&
                        !product.listing?.isOrderWriterOnly &&
                        product?.listingVariantId &&
                        product.listing?.storefront?.isPublished &&
                        product?.canBeReordered
                )
                .map((item) => {
                    return {
                        quantity: item.quantity,
                        listingVariantId:
                            item.listingVariantId || item.listingVariant?.id,
                        storefrontId:
                            item.storefront?.id || item.listing?.storefront?.id,
                    }
                })
            this.$apollo
                .mutate({
                    mutation: ADD_PRODUCTS_TO_CART_MUTATION,
                    variables: {
                        products: itemsToAddToCart,
                    },
                })
                .then(() => {
                    trackAddToCart('Reorder', 'Order Detail', '', {
                        listingIds: itemsToAddToCart.map(
                            (item) => item.listingVariantId
                        ),
                    })

                    this.isButtonLoading = false
                    this.closeModal()
                    EventBus.$emit('show-header-cart')
                })
        },
    },
}
